import { render, staticRenderFns } from "./financialProduct.vue?vue&type=template&id=edbf1dcc&"
import script from "./financialProduct.vue?vue&type=script&lang=js&"
export * from "./financialProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports